export const getQueryParams = () => {
    if (typeof window !== "undefined") {
        const url = window?.location?.href;
        const myURL = new window.URL(url, window?.location?.origin);
        return Object.fromEntries(myURL?.searchParams?.entries());
    }
    return null;

};
